// Disclaimer.jsx
import React from "react";
import { AlertTriangle } from "lucide-react";
import "./LegalPages.css";
import Footer from "./footer";

const Disclaimer = () => {
  return (
    <div className="legal-container">
      <div className="legal-content">
        <div className="legal-header">
          <div className="header-title">
            <AlertTriangle className="header-icon blue" />
            <h1>Disclaimer</h1>
          </div>
          <p className="breadcrumb">Home / Disclaimer</p>
        </div>

        <section className="legal-section">
          <div>
            <h2>1. Nature of The Platform</h2>
            <p>NextGen Prosperity Pvt. Ltd. is an online platform designed to facilitate the buying and selling of unlisted shares and pre-IPO securities in India. It is important to note that NextGen Prosperity Pvt. Ltd. is not a stock exchange or a trading platform recognized by the Securities Exchange Board of India (SEBI) under the Securities Contract (Regulation) Act, 1956 or other relevant regulations.</p>
          </div>

          <div>
            <h2>2. No Investment Advice or Recommendation</h2>
            <p>The platform does not offer investment advice, recommendations, or any assurance or guarantee of returns. All information provided on our website is for educational and informational purposes only. Users must perform their own due diligence and consult independent financial or legal advisors before making any investment decisions.</p>
          </div>

          <div>
            <h2>3. Risk Acknowledgment</h2>
            <p>Investing in unlisted and pre-IPO shares involves significant risks, including lack of liquidity, high volatility, regulatory uncertainties, and the potential loss of the entire investment. Users declare that they fully understand and accept these risks.</p>
          </div>

          <div>
            <h2>4. User Responsibility</h2>
            <p>Buyers and sellers confirm that they are responsible for verifying the authenticity and legality of transactions conducted via the platform. All payments must come from the bank account of the individual buying the shares, and shares will only be transferred to the demat account of the verified buyer. Transactions involving third-party accounts are not permitted, and users agree to bear any legal consequences arising from non-compliance.</p>
          </div>

          <div>
            <h2>5. Compliance with Laws</h2>
            <p>Users confirm that they will comply with all applicable Indian laws and regulations, including those set by SEBI, Reserve Bank of India (RBI), FEMA Act, Companies Act 2013, and any other relevant statutory requirements regarding the purchase or sale of unlisted shares.</p>
          </div>

          <div>
            <h2>6. Limitation of Liability</h2>
            <p>NextGen Prosperity Pvt. Ltd. assumes no liability for any financial losses, damages, or claims resulting from the use of the platform or investment decisions made based on the information provided. The platform acts solely as an intermediary and facilitator and does not guarantee the availability, authenticity, or performance of any shares or investments.</p>
          </div>

          <div>
            <h2>7. Data Accuracy and Updates</h2>
            <p>While we strive to ensure that information on the platform is accurate and up-to-date, we cannot guarantee the completeness or reliability of such data, especially that sourced directly from third parties or company filings. Users should rely on their own verification processes.</p>
          </div>

          <div>
            <h2>8. Transaction Fulfilments</h2>
            <p>If NextGen Prosperity Pvt. Ltd. is unable to complete a transaction due to unavailability of agreed-upon shares or any other issue, the transaction amount will be returned to the user's original payment account promptly.</p>
          </div>
        </section>
      </div>
          <Footer />
    </div>
  );
};

export default Disclaimer;